import * as C from '../constants';

export default {
  /**
   * @param state
   */
  [C.XML_CHANNEL_STATUS_PENDING](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: true,
      error: false,
      noContent: false,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.XML_CHANNEL_STATUS_SUCCESS](state, payload) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: false,
      items: payload.channels,
      systems: payload.systems,
    };
  },

  /**
   * @param state
   */
  [C.XML_CHANNEL_STATUS_FAILURE](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: false,
      error: true,
      items: [],
      systems: [],
    };
  },

  /**
   * @param state
   */
  [C.XML_CHANNEL_STATUS_NO_CONTENT](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: false,
      noContent: true,
      items: [],
      systems: [],
    };
  },

  /**
   * @param state
   */
  [C.XML_JOB_ACTIVATE_PENDING](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: true,
      error: false,
    };
  },

  /**
   * @param state
   */
  [C.XML_JOB_ACTIVATE_SUCCESS](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: false,
      error: false,
    };
  },

  /**
   * @param state
   */
  [C.XML_JOB_ACTIVATE_FAILURE](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   * @param searchWord
   */
  [C.XML_CHANNEL_FILTER_SEARCH](state, searchWord) {
    state.filter = {
      ...state.filter,
      search: searchWord,
    };
  },

  /**
   * @param state
   * @param systemFilter
   */
  [C.XML_CHANNEL_FILTER_SYSTEM](state, systemFilter) {
    state.filter = {
      ...state.filter,
      system: systemFilter,
    };
  },

  /**
   * @param state
   * @param statusFilter
   */
  [C.XML_CHANNEL_FILTER_STATUS](state, statusFilter) {
    state.filter = {
      ...state.filter,
      status: statusFilter,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.XML_JOB_LIST_SET_XML_CHANNEL](state, payload) {
    state.xmlJobList = {
      ...state.xmlJobList,
      xmlChannel: payload,
      items: [],
    };
  },

  /**
   * @param state
   */
  [C.XML_JOB_LIST_PENDING](state) {
    state.xmlJobList = {
      ...state.xmlJobList,
      loading: true,
      error: false,
      noContent: false,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.XML_JOB_LIST_SUCCESS](state, payload) {
    state.xmlJobList = {
      ...state.xmlJobList,
      loading: false,
      items: payload,
    };
  },

  /**
   * @param state
   */
  [C.XML_JOB_LIST_FAILURE](state) {
    state.xmlJobList = {
      ...state.xmlJobList,
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   */
  [C.XML_JOB_LIST_NO_CONTENT](state) {
    state.xmlJobList = {
      ...state.xmlJobList,
      loading: false,
      noContent: true,
    };
  },

  /**
  * @param state
  */
  [C.XML_JOBS_OVERVIEW_PENDING](state) {
    state.xmlJobsOverview = {
      ...state.xmlJobsOverview,
      loading: true,
      error: false,
      noContent: false,
      items: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.XML_JOBS_OVERVIEW_SUCCESS](state, payload) {
    state.xmlJobsOverview = {
      ...state.xmlJobsOverview,
      loading: false,
      error: false,
      noContent: false,
      items: payload,
    };
  },

  /**
   * @param state
   */
  [C.XML_JOBS_OVERVIEW_FAILURE](state) {
    state.xmlJobsOverview = {
      ...state.xmlJobsOverview,
      loading: false,
      error: true,
      noContent: false,
      items: [],
    };
  },

  /**
   * @param state
   */
  [C.XML_JOBS_OVERVIEW_NO_CONTENT](state) {
    state.xmlJobsOverview = {
      ...state.xmlJobsOverview,
      loading: false,
      error: false,
      noContent: true,
      items: [],
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/xmlChannelStatus/mutations.js